import React from "react";
import { Box, Typography, useMediaQuery } from "@mui/material";
import styles from "../../assets/styles/form.module.css";
import { APP_LOGO_URL } from "../../utils/constants";
import getTheme from "../../theme/theme";
import { PinnacleThemes } from "../../theme/types";

interface PinnacleFormContainerProps {
    hideLogo?: boolean
    formDescription?: string;
    formName: string;
    children: React.ReactNode;
}

export default function PinnacleFormContainer({
    formName,
    formDescription,
    hideLogo = false,
    children,
}: PinnacleFormContainerProps) {
    const theme = getTheme(PinnacleThemes.BASE_THEME);
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    return (
        <div className={styles["form-container"]}
        >
            <Box
                className={styles["form-container-box"]}
                sx={{
                    padding: {
                        xs: "16px",
                        sm: "32px",
                    },
                    justifyContent: {
                        xs: "center",
                        sm: "flex-end",
                    },
                    alignItems: {
                        xs: "center",
                        sm: "flex-end",
                    },
                }}
            >
                <Box
                    className={styles["form-panel"]}
                    sx={{
                        ...(isMobile ? { padding: "40px 15px" } : {})
                    }}>
                    {!hideLogo && (
                        <img
                            src={APP_LOGO_URL}
                            alt='pinnacle-logo'
                            className={styles["form-panel-logo"]}
                        />
                    )}
                    <Typography
                        variant="h3"
                        gutterBottom
                        sx={{ marginBottom: 4 }}
                    >
                        {formName}
                    </Typography>

                    {formDescription && (
                        <Typography
                            variant="h5"
                            gutterBottom
                            sx={{ marginBottom: 4 }}
                        >
                            {formDescription}
                        </Typography>
                    )}

                    {children}
                </Box>
            </Box>
        </div>
    );
}
